<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
    <Card>
        <CardSection :title="$t('views.storeSettings.notifications.title')"></CardSection>
        <div style="padding: 1rem 2rem">
            <table class="table table-bordered">
                <thead class="thead-light">
                    <tr>
                        <th class="text-capitalize">{{ $t('views.storeSettings.notifications.columns.type') }}</th>
                        <th class="text-capitalize">{{ $t('views.storeSettings.notifications.columns.system') }}</th>
                        <th class="text-capitalize">{{ $t('views.storeSettings.notifications.columns.mail') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="value in notification_types" :key="value">
                        <td>{{ $t(`views.storeSettings.notifications.options.${value}`) }}</td>
                        <td>
                            <input v-model="form.notification_types.system" :value="value" type="checkbox" class="form-check-input" />
                        </td>
                        <td>
                            <input v-model="form.notification_types.mail" :value="value" type="checkbox" class="form-check-input" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end bordered-top mt-1" style="padding: 1rem 2rem 0 0">
            <button class="btn btn-primary" @click="submit">{{ $t('actions.save') }}</button>
        </div>
    </Card>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Card from '@/components/Layouts/Card.vue'
import CardSection from '@/components/Layouts/CardSection.vue'

export default {
    name: 'StoreSettings',
    components: { Card, CardSection },
    data() {
        return {
            form: {
                notification_types: {
                    system: [],
                    mail: [],
                },
            },
            notification_types: ['brand_change', 'image_change', 'title_change', 'fba_fee_change', 'bsr_change', 'min_price_reached', 'pricing_in_case_of_loss', 'list_closed', 'shipment_status', 'shipment_recieved'],
        }
    },
    computed: {
        ...mapGetters('market', ['markets', 'currentMarket']),
        ...mapState('settings', ['storeSettings']),
    },
    created() {
        this.getStoreSettings(this.currentMarket.idx).then(() => {
            this.form = this.storeSettings
        })
    },
    methods: {
        ...mapActions('settings', ['getStoreSettings', 'setStoreSettings']),
        submit() {
            this.setStoreSettings({ idx: this.currentMarket.idx, payload: { settings: this.form } })
        },
    },
}
</script>

<style lang="scss" scoped>
.store-settings-page {
    margin-top: 30px;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #e7eaf3;
        margin-bottom: 30px;
    }

    h1 {
        font-size: 22px !important;
        font-weight: 500 !important;
        line-height: 21px !important;
        color: #00203f;
    }

    &__title {
        font-size: 15px;
        font-weight: 500;
        line-height: 21px;
        color: #00203f;
        border-bottom: 1px solid #e7eaf3b2;
        padding-bottom: 20px;
    }

    .card-body {
        padding: 2rem;
    }

    label {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #00203f;
        margin-bottom: 10px;
    }

    .table-bordered {
        border-left: transparent;

        thead {
            tr {
                height: 48px;

                th:not(:first-child) {
                    text-align: center;
                }
            }
        }

        tbody {
            tr {
                height: 46px;

                td {
                    width: 100px;

                    &:first-child {
                        min-width: 440px;
                    }

                    &:last-child {
                        border-right: transparent;
                    }

                    &:not(:first-child) {
                        text-align: center;
                    }
                }
            }
        }
    }

    .sku-title {
        min-width: 408px;
        max-width: 408px;
        padding-left: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        vertical-align: middle;
    }

    .secondary-primary {
        color: #fff !important;
        background-color: var(--bs-gray-700) !important;

        &:hover {
            background-color: var(--fba-primary) !important;
        }
    }

    select,
    .form-control {
        height: 41px !important;

        &::placeholder {
            font-size: 13px;
        }
    }

    .input-group-text {
        background-color: #fff !important;
        font-size: 13px;
    }

    .form-check-label {
        font-size: 13px;
        color: #677788;
    }

    .form-check-input {
        &:not(:checked):focus {
            border: 1px solid #11214399;
        }
    }
    .multiselect {
        min-width: 100% !important;
    }
}
@media (width <= 767px) {
    .store-settings-page .table-bordered tbody tr td:first-child {
        min-width: auto !important;
    }
    table {
        margin-left: -1.5rem !important;

        th,
        td {
            font-size: 12px;
        }
    }
}
@media (768px <= width <= 1024px) {
    .store-settings-page .table-bordered tbody tr td:first-child {
        min-width: auto !important;
    }
}
@media (1025px <= width <= 1366px) {
}
</style>
